import { Component, OnInit, Input, Output, EventEmitter, ViewChild, HostBinding } from '@angular/core';
import { TimeInputComponent } from '../time-input/time-input.component';
import { MatSlideToggleChange } from '@angular/material';
import { Reminder } from '../../../shared/models/Reminder';
import { AchievementService } from 'app/shared/services/achievement.service';

@Component({
  selector: 'app-reminder-box',
  templateUrl: './reminder-box.component.html',
  styleUrls: ['./reminder-box.component.scss'],
})
export class ReminderBoxComponent implements OnInit {
  @Input() editing: boolean = false;
  @Input() canEdit: boolean = true;
  @Input() canAdd: boolean = false;
  reminderValue: Reminder;
  @Input()
  set reminder(val) {
    this.reminderValue = val;

    this.disabled = !this.reminder.isActive;
  }
  get reminder() {
    return this.reminderValue;
  }

  @Output() startEditing = new EventEmitter<any>();
  @Output() doneEditing = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();

  disabled: boolean = false;

  @ViewChild(TimeInputComponent) timeinput: TimeInputComponent;

  constructor(private achievementService: AchievementService) {}

  @HostBinding('class.editing') editingClass: boolean = false;

  ngOnInit() {
    if (this.canAdd) {
      this.editing = true;
    }
  }

  toggleActive(e: MatSlideToggleChange) {
    this.disabled = !e.checked;
    this.reminder.isActive = e.checked;

    this.doneEditing.emit(this);
  }

  reset() {
    this.timeinput.reset();
  }

  save() {
    if (this.evaluate()) {
      this.editing = false;
      this.editingClass = false;
      this.doneEditing.emit(this);
    }
  }

  saveNew() {
    if (this.evaluate()) {
      this.doneEditing.emit(this);
    }
  }

  evaluate(): boolean {
    // only enable save if at least one day is enabled and time is set
    if (this.reminder.time.hours == undefined || this.reminder.time.minutes == undefined) {
      this.reminder.time.hours = this.reminder.time.hours || 0;
      this.reminder.time.minutes = this.reminder.time.minutes || 0;
    }
    let setDays = false;
    for (const day of Object.keys(this.reminder.repeatOnDays)) {
      setDays = this.reminder.repeatOnDays[day] || setDays;
    }

    if (!setDays) {
      return false;
    }

    return true;
  }

  remove() {
    this.delete.emit(this);
  }

  edit() {
    if (this.canEdit) {
      this.editing = true;
      this.editingClass = true;
      this.startEditing.emit(this);
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/reminder-box/reminder-box.component.ts